export enum Duration {
  In = 100,
  Out = 150,
}

export const Timing = {
  In: `${Duration.In}ms ease-in`,
  Out: `${Duration.Out}ms ease-out`,
};
